'use client'

import { updateCustomer } from '@onclicks/sharedmedusa/medusaData/customer'
import { Input } from '../ui/input'
import { Button } from '../ui/Button'
import { bagelFatOne } from '@/utilities/fontImport'
import { cn } from '@/utilities/ui'
import { showToast } from '../ui/feedback/custom-toast-shortcut'
import { useRouter } from 'next/navigation'

const AccountDetails = ({ customer }: { customer: any }) => {
  const router = useRouter()

  async function handleSubmitUpdateCustomer(formData: FormData) {
    const data = {
      first_name: formData.get('first_name') as string,
      last_name: formData.get('last_name') as string,
    }

    try {
      await updateCustomer(data)
      showToast.success('Modifications enregistrées !')
      router.refresh()
    } catch (e) {
      console.error(e)
      showToast.error("Erreur lors de l'enregistrement des informations")
    }
  }

  return (
    <div className="rounded-[2.5rem] border border-white bg-white shadow-xl shadow-light-pink/40 p-8 lg:p-10">
      <h2 className={cn('text-2xl font-bold mb-1 text-primary', bagelFatOne.className)}>
        Détails du compte
      </h2>
      <p className="font-semibold text-primary/55 text-sm mb-7">
        Gérez vos informations personnelles.
      </p>

      <form action={handleSubmitUpdateCustomer} className="flex flex-col">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
          <Input
            label="Prénom"
            id="first_name"
            type="text"
            name="first_name"
            defaultValue={customer.first_name}
          />

          <Input
            label="Nom"
            id="last_name"
            type="text"
            name="last_name"
            defaultValue={customer.last_name}
          />
        </div>

        <Input
          label="Adresse e-mail"
          id="email"
          type="email"
          name="email"
          readOnly
          disabled
          defaultValue={customer.email}
        />

        <Button type="submit" className="w-fit mt-8" variant="gradientOrangeToPink">
          Enregistrer les modifications
        </Button>
      </form>
    </div>
  )
}

export default AccountDetails
